import React, { useState } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
  Avatar,
  Alert,
  CircularProgress
} from '@mui/material';
import locationService from '../../services/locationService';

const EnrollmentModal = ({ open, onClose, location, onSuccess }) => {
  const [enrolling, setEnrolling] = useState(false);
  const [enrollmentError, setEnrollmentError] = useState(null);

  const handleEnrollConfirm = async () => {
    if (!location) return;

    try {
      setEnrolling(true);
      setEnrollmentError(null);

      await locationService.enrollInGroup(location.group_id || location.id);

      // Call the success callback
      if (onSuccess) {
        onSuccess(location);
      }

      // Close modal
      onClose();
    } catch (error) {
      console.error('Enrollment error:', error);
      setEnrollmentError('Failed to enroll. Please try again.');
      setEnrolling(false);
    }
  };

  const handleClose = () => {
    if (!enrolling) {
      setEnrollmentError(null);
      onClose();
    }
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="sm"
      fullWidth
    >
      <DialogTitle sx={{ textAlign: 'center', pt: 3 }}>
        <Typography variant="h5" component="div">
          Join Rewards Program
        </Typography>
      </DialogTitle>
      <DialogContent>
        {location && (
          <Box sx={{ textAlign: 'center', py: 2 }}>
            {location.logo && (
              <Avatar
                src={location.logo}
                sx={{
                  width: 80,
                  height: 80,
                  mx: 'auto',
                  mb: 2,
                  boxShadow: 1
                }}
              />
            )}
            <Typography variant="body1" sx={{ mb: 3 }}>
              You are joining <strong>{location.name || location.location_name}</strong>'s
              Rewards program. By doing so you are agreeing to receive text messages,
              this is not required to make a purchase.
            </Typography>
            {enrollmentError && (
              <Alert severity="error" sx={{ mb: 2 }}>
                {enrollmentError}
              </Alert>
            )}
          </Box>
        )}
      </DialogContent>
      <DialogActions sx={{ pb: 3, px: 3 }}>
        <Button
          onClick={handleClose}
          disabled={enrolling}
        >
          Cancel
        </Button>
        <Button
          variant="contained"
          onClick={handleEnrollConfirm}
          disabled={enrolling}
        >
          {enrolling ? <CircularProgress size={24} /> : 'Confirm'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default EnrollmentModal;